import React from 'react';
import { Row, Col } from 'antd';
import styles from './style.module.less';

const Education = ({ profile_list }) => {
  const profiles = profile_list?.Profiles;
  const profileData =
    Array.isArray(profiles) && profiles.length > 0 ? profiles[0] : profiles;

  const {
    employed_in,
    company_name,
    designation,
    City,
    ProfileEducations,
    Department
  } = profileData || {};

  // const highestQualification =
  //   ProfileEducations?.[0]?.HigherEducation?.higher_education || 'N/A';
  const highestQualification =
    ProfileEducations?.map((edu) => edu.HigherEducation?.education)
      .filter(Boolean) // Remove undefined values
      .join(', ') || 'Not provided';
  const workLocation = City ? `${City.city}, ${City.state_id}` : 'Not provided';
  const employmentType = employed_in || 'Not provided';
  const companyName = company_name || 'Not provided';
  const department = Department?.department || 'Not provided';
  const designationValue = designation || 'Not provided';

  console.log('Education_details', highestQualification);

  return (
    <>
      <Row className={styles.edu}>
        <Col className={styles.colStyle}>
          <span className={styles.highqualification}>
            Highest Qualification
          </span>

          {/* <span className={styles.edu2}> {highestQualification} </span> */}
        </Col>
      </Row>

      <Row className={styles.eduHeader}>
        <Col span={8}>
          <span className={styles.subHeader}>Level of Education</span>
        </Col>
        <Col span={8}>
          <span className={styles.subHeader}>Degree</span>
        </Col>
        <Col span={8}>
          <span className={styles.subHeader}>Name of Institution</span>
        </Col>
      </Row>

      {ProfileEducations?.map((edu, index) => (
        <Row key={index} className={styles.eduRow}>
          <Col span={8}>
            <span className={styles.eduText}>
              {edu?.EducationLevel?.education_level || 'Not provided'}
            </span>
          </Col>
          <Col span={8}>
            <span className={styles.eduText}>
              {edu?.HigherEducation?.higher_education || 'Not provided'}
            </span>
          </Col>
          <Col span={8}>
            <span className={styles.eduText}>
              {edu?.institute_name || 'Not provided'}
            </span>
          </Col>
        </Row>
      ))}

      <Row getter={24} className={styles.fam}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.high}>Employee In</span>
          <span className={styles.edu2}> {employmentType} </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.high}>Department</span>
          <span className={styles.edu2}> {department} </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.high}>Work Location</span>
          <span className={styles.edu2}> {workLocation} </span>
        </Col>
      </Row>

      <Row getter={24} className={styles.fam} style={{ paddingTop: '10px' }}>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.high}>Designation</span>
          <span className={styles.edu2}> {designationValue} </span>
        </Col>
        <Col span={8} className={styles.colStyle}>
          <span className={styles.high}>Company Name</span>
          <span className={styles.edu2}> {companyName} </span>
        </Col>
      </Row>
    </>
  );
};

export default Education;
